import { styled } from '@linaria/react';
import { fonts, semantic, space } from '../../theme/tokens';

export const ScrollContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-400']};
  width: 100%;
  min-width: 0;
`;

export const Intro = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${space['space-200']};
`;

export const MetaText = styled.p`
  font-family: ${fonts.body};
  font-size: ${fonts.size.base};
  color: ${semantic.text.secondary};
  margin: 0;
`;

export const ErrorRow = styled.div`
  display: flex;
  justify-content: center;
`;
